import { render, staticRenderFns } from "./Weine.vue?vue&type=template&id=297979a4&scoped=true"
import script from "./Weine.vue?vue&type=script&lang=js"
export * from "./Weine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297979a4",
  null
  
)

export default component.exports